import { Location } from '@cpd-app/core-module/models';

/**
 * #37 (walkthrough 29 Sep, approved): "I want to live outside the U.S." as one
 * of the places a member wants to live.
 *
 * Saved as one row in api.userpreferredlocations, beside the member's U.S.
 * places, with fipscode -1. Not 0: many existing rows already hold 0 (see
 * location-scope.ts), and those must keep scoring as they do. -1 is never a
 * county. The backend's lifestyle match gives it U.S. national pay and
 * demand; every other reader of preferred places skips it, and the name is
 * what the Goals Report and portfolio show.
 */
export const OUT_OF_US_FIPS = -1;

export const OUT_OF_US_PREFERRED: Location = {
  name: 'Outside the U.S.',
  fipsCode: OUT_OF_US_FIPS,
  lat: 0,
  lon: 0,
  zipCode: ''
} as Location;

/** The saved row, in whichever shape it arrives (survey, GraphQL or table). */
export function isOutsideUsPlace(location: unknown): boolean {
  const l = (location ?? {}) as {
    fipsCode?: number | string | null;
    countyFipsCode?: number | string | null;
    fipscode?: number | string | null;
  };
  const fips = l.fipsCode ?? l.countyFipsCode ?? l.fipscode;
  return (
    fips !== null &&
    fips !== undefined &&
    fips !== '' &&
    Number(fips) === OUT_OF_US_FIPS
  );
}
